/**
 * Persists a human review for a medical PA order via Postgres insert.
 * @module saveReviewData
 */

import { singleOrderDetailsGenericInsert } from "../postgreSQL/postCalls/singleOrderDetailsGenericInsert";
import { ReviewInsertData } from "../../data-model/reviewModel";
import { SingleOrderDetailsTableName } from "../../enums/singleOrderDetailsTableName";

export type { ReviewData, ReviewInsertData } from "../../data-model/reviewModel";

/** Parameters for inserting a review row. */
export interface SaveReviewDataParams {
  orderId: string;
  orgId: string;
  data: ReviewInsertData;
}

/**
 * Inserts a review record into Postgres using the generic single-order insert API.
 *
 * @param params - Order ID, org ID, and review column values.
 * @throws {Error} When the insert request fails or returns `success: false`.
 */
export const saveReviewData = async (
  params: SaveReviewDataParams,
): Promise<void> => {
  const result = await singleOrderDetailsGenericInsert<ReviewInsertData>({
    order_id: params.orderId,
    org_id: params.orgId,
    table_name: SingleOrderDetailsTableName.REVIEWS,
    data: params.data,
  });

  if (!result.success) {
    throw new Error("Failed to save review data");
  }
};
